import React, {
    useState,
    useImperativeHandle,
    Fragment,
} from "react";
import {
    Button,
    Select,
    DatePicker,
    Input,
    Icon
} from "@kdcloudjs/kdesign";
import "@kdcloudjs/kdesign/dist/kdesign.css";
import "./css/style.less";

import { getDateLocalConfig } from "./dateLocal"

const TodoList = (props) => {
    console.log(props, "props");

    const { I18N } = props

    // const [form] = Form.useForm()
    const [collapse, setCollapse] = useState(false);
    const [searchForm, setSearchForm] = useState({
        bsedDate: new Date(),
        bsed: new Date().toLocaleDateString().replaceAll('/', '-'),
        adminorg: "",
        adminorgname: "",
        org: "",
        orgname: "",
        positiontype: "",
        positiontypename: "",
        positionclassify: "",
        positionclassifyname: "",
        group: "",
        groupname: "",
        keyposition: "",
        keypositionname: "",
        deputytype: "",
        deputytypename: "",
        isleader: "",
        jobscmt: "",
        jobscmname: "",
        jobseq: "",
        jobseqname: "",
        jobfamily: "",
        jobfamilyname: "",
        jobclass: "",
        jobclassname: "",
        job: "",
        jobname: "",
    });

    const style = {
        collapsed: {
            display: "none",
            heigth: "0px",
        },
        expanded: {
            display: "block",
            height: "220px",
        },
    };

    useImperativeHandle(props.onRef, () => ({
        updateField: (data, eventName) => {
            setSearchForm({
                ...searchForm,
                [eventName]: data.id,
                [eventName + "name"]: data.name,
            });
        },
    }));

    // 监听响应下层组件的事件
    const dateChange = (date, dateString) => {
        setSearchForm({
            ...searchForm,
            bsedDate: date,
            bsed: dateString.replaceAll('/', '-'),
        });
    };
    const onSelectChange = (value) => {
        setSearchForm({
            ...searchForm,
            isleader: value,
        });
    };
    const changeInput = (key, e) => {
        setSearchForm({
            ...searchForm,
            [key]: "",
            [key + "name"]: e.target.value,
        });
    };

    // 事件组（发事件给后端）：
    const showAdminOrghr = () => {
        props.model.invoke("adminorg");
    };
    const showOrg = () => {
        props.model.invoke("org");
    };
    const showPositionType = () => {
        props.model.invoke("positiontype");
    };
    const showPositionClassify = () => {
        props.model.invoke("positionclassify");
    };
    const showPositionGroup = () => {
        props.model.invoke("group");
    };
    const showKeyPositionType = () => {
        props.model.invoke("keyposition");
    };
    const showDeputyType = () => {
        props.model.invoke("deputytype");
    };
    const showJobScm = () => {
        props.model.invoke("jobscm");
    };
    const showJobSeqhr = () => {
        if (!searchForm.jobscmname) {
            props.myTool.message({
                type: 'warn',
                message: I18N("tips.jobscmname")
            });
            return;
        }
        props.model.invoke("jobseq");
    };
    const showJobFamilyhr = () => {
        if (!searchForm.jobseqname) {
            props.myTool.message({
                type: 'warn',
                message: I18N("tips.jobseqname")
            });
            return;
        }
        props.model.invoke("jobfamily");
    };
    const showJobClasshr = () => {
        if (!searchForm.jobfamilyname) {
            props.myTool.message({
                type: 'warn',
                message: I18N("tips.jobfamilyname")
            });
            return;
        }
        props.model.invoke("jobclass");
    };
    const showJobhr = () => {
        if (!searchForm.jobclassname) {
            props.myTool.message({
                type: 'warn',
                message: I18N("tips.jobclassname")
            });
            return;
        }
        props.model.invoke("job");
    };
    // 查询事件
    const queryData = () => {
        console.log(searchForm, "searchForm");
        props.model.invoke("query", searchForm);
    };
    const showClose = (type, e) => {
        if (searchForm[type]) {
            e.currentTarget.querySelector('.kd-input-clear-icon-hidden').style.visibility = 'visible';
        }
    };
    const hideClose = (type, e) => {
        e.currentTarget.querySelector('.kd-input-clear-icon-hidden').style.visibility = 'hidden';
    };


    //所有组件：
    const fieldList = [
        {
            type: "DatePicker",
            name: I18N("filt.date"),
            className: "wrapper-border",
            value: searchForm.bsedDate,
            onChange: (a, b) => dateChange(a, b),
        },
        {
            type: "InputSearch",
            name: I18N("filt.org"),
            className: "wrapper-border",
            value: searchForm.adminorgname,
            showPop: () => showAdminOrghr(),
            showClose: (e) => showClose("adminorg", e),
            hideClose: (e) => hideClose("adminorg", e),
            onChange: (e) => changeInput("adminorg", e),
        },
        {
            type: "InputSearch",
            name: I18N("filt.master"),
            className: "wrapper-border",
            value: searchForm.orgname,
            showPop: () => showOrg(),
            onChange: (e) => changeInput("org", e),
            showClose: (e) => showClose("org", e),
            hideClose: (e) => hideClose("org", e),
        },
        {
            type: "InputSearch",
            name: I18N("filt.postType"),
            className: "wrapper-border",
            value: searchForm.positiontypename,
            showPop: () => showPositionType(),
            onChange: (e) => changeInput("positiontype", e),
            showClose: (e) => showClose("positiontype", e),
            hideClose: (e) => hideClose("positiontype", e),
        },
        {
            type: "InputSearch",
            name: I18N("filt.postClassify"),
            className: "wrapper-border",
            value: searchForm.positionclassifyname,
            showPop: () => showPositionClassify(),
            onChange: (e) => changeInput("positionclassify", e),
            showClose: (e) => showClose("positionclassify", e),
            hideClose: (e) => hideClose("positionclassify", e),
        },
        {
            type: "InputSearch",
            name: I18N("filt.posts"),
            className: "wrapper-border",
            value: searchForm.groupname,
            showPop: () => showPositionGroup(),
            onChange: (e) => changeInput("group", e),
            showClose: (e) => showClose("group", e),
            hideClose: (e) => hideClose("group", e),
        },
        {
            type: "InputSearch",
            name: I18N("filt.mainPostType"),
            className: "wrapper-border",
            value: searchForm.keypositionname,
            showPop: () => showKeyPositionType(),
            onChange: (e) => changeInput("keyposition", e),
            showClose: (e) => showClose("keyposition", e),
            hideClose: (e) => hideClose("keyposition", e),
        },
        {
            type: "InputSearch",
            name: I18N("filt.subPostType"),
            className: "wrapper-border",
            value: searchForm.deputytypename,
            showPop: () => showDeputyType(),
            onChange: (e) => changeInput("deputytype", e),
            showClose: (e) => showClose("deputytype", e),
            hideClose: (e) => hideClose("deputytype", e),
        },
        {
            type: "Select",
            name: I18N("filt.isMain"),
            className: "wrapper-border",
            value: searchForm.isleader,
            onChange: (value) => onSelectChange(value),
        },
        {
            type: "InputSearch",
            name: I18N("filt.postPro"),
            className: "wrapper-border",
            value: searchForm.jobscmname,
            showPop: () => showJobScm(),
            onChange: (e) => changeInput("jobscm", e),
            showClose: (e) => showClose("jobscm", e),
            hideClose: (e) => hideClose("jobscm", e),
        },
        {
            type: "InputSearch",
            name: I18N("filt.postSeq"),
            className: "wrapper-border",
            value: searchForm.jobseqname,
            showPop: () => showJobSeqhr(),
            onChange: (e) => changeInput("jobseq", e),
            showClose: (e) => showClose("jobseq", e),
            hideClose: (e) => hideClose("jobseq", e),
        },
        {
            type: "InputSearch",
            name: I18N("filt.postFamily"),
            className: "wrapper-border",
            value: searchForm.jobfamilyname,
            showPop: () => showJobFamilyhr(),
            onChange: (e) => changeInput("jobfamily", e),
            showClose: (e) => showClose("jobfamily", e),
            hideClose: (e) => hideClose("jobfamily", e),
        },
        {
            type: "InputSearch",
            name: I18N("filt.postClass"),
            className: "wrapper-border",
            value: searchForm.jobclassname,
            showPop: () => showJobClasshr(),
            onChange: (e) => changeInput("jobclass", e),
            showClose: (e) => showClose("jobclass", e),
            hideClose: (e) => hideClose("jobclass", e),
        },
        {
            type: "InputSearch",
            name: I18N("filt.post"),
            className: "wrapper-border",
            value: searchForm.jobname,
            showPop: () => showJobhr(),
            onChange: (e) => changeInput("job", e),
            showClose: (e) => showClose("job", e),
            hideClose: (e) => hideClose("job", e),
        },
    ];

    console.log(getDateLocalConfig(I18N("yes") === "yes" ? "en" : "cn"));

    //组织所有组件的html
    const getFields = () => {
        const children = [];
        fieldList.map((item) => {
            // 区分渲染三种控件类型：
            switch (item.type) {
                case "DatePicker":
                    children.push(
                        <div className="filter-item" key={item.name}>
                            <label title={item.name} className="label">
                                <span>{item.name}</span>
                                <span className="filter-item-necessary">*</span>
                            </label>
                            <DatePicker
                                locale={getDateLocalConfig(I18N("yes") === "yes" ? "en" : "cn")}
                                className={item?.className || ""}
                                size="small"
                                value={item.value}
                                format="yyyy/MM/dd"
                                allowClear={false}
                                onChange={item?.onChange || null}
                            />
                        </div>
                    );
                    break;
                case "InputSearch":
                    children.push(
                        <div className="filter-item" key={item.name} onMouseOver={item?.showClose || null} onMouseLeave={item?.hideClose || null}>
                            <label title={item.name} className="label">
                                {item.name}
                            </label>
                            <Input
                                disabled={true}
                                allowClear
                                className={item?.className || ""}
                                value={item.value}
                                borderType="bordered"
                                placeholder=""
                                onChange={item?.onChange || null}
                                suffix={
                                    <Icon type="search" onClick={item?.showPop || null}></Icon>
                                }
                            />
                        </div>
                    );
                    break;
                case "Select":
                    children.push(
                        <div className="filter-item" key={item.name}>
                            <label title={item.name} className="label">
                                {item.name}
                            </label>
                            <Select
                                allowClear
                                className={item?.className || ""}
                                borderType="bordered"
                                placeholder={I18N("selectPlaceholder")}
                                onChange={item?.onChange || null}
                                value={item.value}
                            >
                                <Option value="1">{I18N("yes")}</Option>
                                <Option value="0">{I18N("no")}</Option>
                            </Select>
                        </div>
                    );
                    break;
            }
        });
        return children;
    };


    return (
        <Fragment>
            <div className="collapse-btn-wrapper">
                <div className="position-query-title">{I18N("main.title")}</div>
                <Button type="text" className="button-basic-right collapse-btn" onClick={() => setCollapse(!collapse)}>
                    <span>{collapse ? I18N("op.open") : I18N("op.close")}</span>
                </Button>
                <span className={collapse ? 'collapse-btn-icon kdfont kdfont-xiala' : 'collapse-btn-icon kdfont kdfont-shangla'}></span>
            </div>
            <div className="filter-panel" style={collapse ? style.collapsed : style.expanded} aria-expanded={collapse}>
                <div className="filter-content-wrapper">
                    <div className="filter-content">{getFields()}</div>
                    <Button className="search-btn" onClick={queryData}>
                        {I18N("btn.search")}
                    </Button>
                </div>
            </div>
        </Fragment>
    );
};

export default TodoList;
